import dayjs from 'dayjs'
import React, { RefObject } from 'react'
import { SubmitHandler, UseFormReturn } from 'react-hook-form'
import { IClient, IGetClientListName } from 'src/app/shared/models/clientSetup.model'
import { CustomConfirmationModalRef } from '../components/CustomConfirmationModal'
import { PayeeMatchWarningRef } from '../components/PayeeMatchWarningModal'
import { NewAccountFormValues } from '../models'

export enum AccountStatus {
  New = 'new',
  Active = 'active',
  ARCHIVE = 'archive',
  UNARCHIVE = 'unarchive',
}

export interface NewAccountContextProps {
  loading: boolean
  form: UseFormReturn<NewAccountFormValues>
  checkExceptionProcessingType: string
  achExceptionProcessingType: string
  clientList: IGetClientListName.Response
  client: IClient | null
  modalRef: RefObject<CustomConfirmationModalRef>
  payeeMatchWarningRef: RefObject<PayeeMatchWarningRef>
  onSubmit: SubmitHandler<NewAccountFormValues>
  activationDateWarning?: dayjs.Dayjs | null
  // onMakeActive: () => Promise<any>
}

export const NewAccountContext = React.createContext<NewAccountContextProps>({
  loading: false,
  form: null as any,
  checkExceptionProcessingType: '',
  achExceptionProcessingType: '',
  clientList: [],
  client: null,
  modalRef: null as any,
  payeeMatchWarningRef: null as any,
  onSubmit: () => {},
  // onMakeActive: () => Promise.resolve({}),
  activationDateWarning: null,
})

export const useNewAccountContext = () => React.useContext<NewAccountContextProps>(NewAccountContext)
